import React from 'react';
import { observer } from 'mobx-react';
import { Formik, Form } from 'formik';
import { autoGrowTextarea } from '../../../../../../utils/dom';

import { Send } from '@material-ui/icons';

import { RootStoreContext } from '../../../../../../context';

import './MessageInput.css';
import RecordAudio from '../../../../../RecordAudio/RecordAudio';
import withUser from './withUser';

@withUser
@observer
class MessageInput extends React.Component {
  
  static contextType = RootStoreContext;
  
  state = {
    expandedControls: false
  }

  inputRef = React.createRef();
  containerRef = React.createRef();

  inputHeight = 0;

  componentDidMount () {
    autoGrowTextarea(this.inputRef.current, this.onInputHeightChange);
  }

  componentWillUnmount () {
    this.context.privateMessagingStore.setInputAreaHeight(0);
  }

  onInputHeightChange = height => {
    if (height !== this.inputHeight) {
      this.inputHeight = height;
      this.context.privateMessagingStore.setInputAreaHeight(
        this.containerRef.current.offsetHeight
      );
    }
  }

  sendMessage = (values, actions) => {
    if (values.message) {
      this.context.privateMessagingStore.sendMessage(values.message);
      actions.resetForm();
    }
  };

  onInputKeyPress = (event, submit) => {
    if (event.charCode === 13 && !event.shiftKey) {
      event.preventDefault();
      submit();
    }
  }
  
  dataAvailableRecordAudio = (payload) => {
    this.context.privateMessagingStore.sendAudioMessage(payload);
  };
  
  expandedCallbackRecordAudio = (state) => {
    this.setState({
      expandedControls: state
    })
  }

  render () {
    const { expandedControls } = this.state;
    const isAnchor = this.props.user.user.account.anchor;
    const inputWrapperClassName = `
      inputWrapper ${expandedControls ? 'expanded' : ''} 
      ${!isAnchor ? 'addBorderRight' : ''}
    `;
    return (
      <div id="private-chat-message-input" ref={this.containerRef}>
        <Formik
          initialValues={{ message: '' }}
          onSubmit={this.sendMessage}>
          {props => {
            const hintTextVisible = props.values.message.length > 3;
            return (
              <Form autoComplete={'off'}>
                <div className="wrapper">
                  <div className={inputWrapperClassName}>
                    <textarea
                      name="message"
                      ref={this.inputRef}
                      type="text"
                      placeholder="Type something..."
                      onChange={props.handleChange}
                      onKeyPress={event => { this.onInputKeyPress(event, props.submitForm) }}
                      value={props.values.message}
                    />
                  </div>
                  {isAnchor && (
                    <RecordAudio
                      dataAvailable={this.dataAvailableRecordAudio}
                      expandedCallback={this.expandedCallbackRecordAudio}
                    />
                  )}
                  {!expandedControls && (
                    <div>
                      <button type="submit" className="send-icon">
                        <Send fontSize="inherit" />
                      </button>
                    </div>
                  )}
                </div>
                <div
                  className={`controls-hint ${hintTextVisible ? 'controls-hint--visible' : ''}`}>
                  <code>Enter</code> send &nbsp;&nbsp; <code>Shift+Enter</code> new line
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    );
  }
}

export default MessageInput;